import PropTypes from "prop-types";
import Select from "@components/ui-components/select";
import classnames from "classnames";

const pageBtnClass =
  "flex h-7 min-w-7 items-center justify-center rounded text-sm font-medium disabled:cursor-not-allowed disabled:opacity-40";

const PageButton = ({ disabled, onClick, children }) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    className={classnames(
      pageBtnClass,
      disabled
        ? "bg-gray-100 text-gray-400"
        : "bg-primary text-white hover:opacity-90"
    )}
  >
    {children}
  </button>
);

const PaginationBar = ({
  pageIndex,
  pageSize,
  total,
  rowsPerPageOptions,
  onPageChange,
  onRowsPerPageChange
}) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (pageIndex * pageSize) + 1;
  const to = Math.min((pageIndex + 1) * pageSize, total);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-1 py-2 text-sm">
      <div className="flex items-center gap-2">
        <span>Rows per page:</span>
        <Select
          id="rows-per-page"
          size="xs"
          isSearchable={false}
          value={pageSize}
          options={rowsPerPageOptions}
          onChange={(value) => onRowsPerPageChange(Number(value))}
        />
      </div>

      <span>
        {from}–{to} of {total}
      </span>

      <div className="flex items-center gap-1">
        <PageButton disabled={pageIndex === 0} onClick={() => onPageChange(0)}>
          {"«"}
        </PageButton>
        <PageButton
          disabled={pageIndex === 0}
          onClick={() => onPageChange(pageIndex - 1)}
        >
          {"‹"}
        </PageButton>
        <span className="px-2">
          Page {pageIndex + 1} / {totalPages}
        </span>
        <PageButton
          disabled={pageIndex >= totalPages - 1}
          onClick={() => onPageChange(pageIndex + 1)}
        >
          {"›"}
        </PageButton>
        <PageButton
          disabled={pageIndex >= totalPages - 1}
          onClick={() => onPageChange(totalPages - 1)}
        >
          {"»"}
        </PageButton>
      </div>
    </div>
  );
};

PaginationBar.propTypes = {
  pageIndex          : PropTypes.number.isRequired,
  pageSize           : PropTypes.number.isRequired,
  total              : PropTypes.number.isRequired,
  rowsPerPageOptions : PropTypes.arrayOf(PropTypes.number).isRequired,
  onPageChange       : PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired
};

export default PaginationBar;
